"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnvironmentType = exports.STAGING = exports.PRODUCTION_EU = exports.PRODUCTION = exports.LOCAL = exports.LOAD = void 0;
var PRODUCTION = exports.PRODUCTION = 'production';
var PRODUCTION_EU = exports.PRODUCTION_EU = 'production-eu';
var STAGING = exports.STAGING = 'T2';
var LOAD = exports.LOAD = 'L2';
var LOCAL = exports.LOCAL = 'local';
var envTypesMap = new Map([['pr50', PRODUCTION], ['pr51', PRODUCTION], ['pr53', PRODUCTION_EU], ['pr54', PRODUCTION_EU], ['local', LOCAL], ['ci', STAGING], ['sg50', STAGING], ['ld50', LOAD]]);
var getEnvironmentType = exports.getEnvironmentType = function getEnvironmentType(env) {
  return envTypesMap.get(env) || env;
};